// src/components/Hero/Hero.jsx
import React from 'react';
import { motion } from 'framer-motion';
import ConsultationPage from '../Consultation/consult';

const Hero = () => {
  return (
    <div></div>
  );
};

export default Hero;
